import { render, staticRenderFns } from "./sales-gallery.vue?vue&type=template&id=106ebf5a"
import script from "./sales-gallery.vue?vue&type=script&lang=js"
export * from "./sales-gallery.vue?vue&type=script&lang=js"
import style0 from "./sales-gallery.vue?vue&type=style&index=0&id=106ebf5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports